var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"navbar"}},[_c('b-navbar',{attrs:{"type":"dark","sticky":""}},[_c('b-container',[_c('b-navbar-brand',{attrs:{"href":"https://rein.app"}},[_c('b',[_vm._v("rein")]),_vm._v(".app ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }